import { useTheme } from 'styled-components';
import {
  ChartBar, ChartFunnel, ChartLine, ChartPie, ChartRadar, ChartTable, ChartValue, ChartWaffle,
} from '../../../juristec-ui/icons';

const ChartIcon = ({ type }: { type: string }) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const theme = useTheme() as any;

  switch (type) {
    case 'Bar': return (
      <>
        <ChartBar primary={theme.primary} secondary={theme.secondary} />
        <span>Barras</span>
      </>
    );
    case 'Pie': return (
      <>
        <ChartPie primary={theme.primary} secondary={theme.secondary} />
        <span>Pizza</span>
      </>
    );
    case 'Line': return (
      <>
        <ChartLine primary={theme.primary} secondary={theme.secondary} />
        <span>Linha</span>
      </>
    );
    case 'Value': return (
      <>
        <ChartValue primary={theme.primary} secondary={theme.secondary} />
        <span>Valor</span>
      </>
    );
    case 'Table': return (
      <>
        <ChartTable primary={theme.primary} secondary={theme.secondary} />
        <span>Tabela</span>
      </>
    );
    case 'Radar': return (
      <>
        <ChartRadar primary={theme.primary} secondary={theme.secondary} />
        <span>Radar</span>
      </>
    );
    case 'Funnel': return (
      <>
        <ChartFunnel primary={theme.primary} secondary={theme.secondary} />
        <span>Funil</span>
      </>
    );
    case 'Waffle': return (
      <>
        <ChartWaffle primary={theme.primary} secondary={theme.secondary} />
        <span>Waffle</span>
      </>
    );
    default:
      return <></>;
  }
};

export default ChartIcon;
